import { AfterViewInit, Component, OnInit, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { fillTemplateWithData } from '../../routines';
import { AbstractCallComponent } from '../abstract-call/abstract-call.component';

@Component({
    selector: 'se-iframe-call',
    templateUrl: './iframe-call.component.html',
    styleUrls: ['../call-style/call.scss'],
    imports: [TranslateModule, MatButtonModule],
    standalone: true,
})
export class IframeCallComponent extends AbstractCallComponent implements OnInit, AfterViewInit {
    private readonly domSanitizer = inject(DomSanitizer);
    url: SafeResourceUrl | null = null;

    ngOnInit(): void {
        super.ngOnInit();
        const url = this.parseUrlWithData();
        this.url = url ? this.domSanitizer.bypassSecurityTrustResourceUrl(url) : null;
    }

    parseUrlWithData = (): string => {
        if (!this.call.url) return '';
        if (this.dataStore) {
            return fillTemplateWithData(this.dataStore, this.call.placeholders, this.call.url);
        } else {
            return this.call.url;
        }
    };

    ngAfterViewInit(): void {
        if (this.url) this.showLoading.set(true);
    }

    close(): void {
        this.end();
    }

    onLoad() {
        this.showLoading.set(false);
    }
}
